import CustomInput from "../Custom/CustomInput";
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import CustomButton from "../Custom/CustomButton";
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

const ShippingModal = ({ formData, handleInputChange, customOnChange, onClose, isOpen, localStorageData, totalPrice, shipping, taxes }) => {
    const [cities, setCities] = useState([]);
    const [countries, setCountries] = useState([]);
    const [loading, setLoading] = useState(true);
    const [saveIsLoading, setSaveIsLoading] = useState(false);
    const [errorMsg, setErrorMsg] = useState("");
    const [waOptin, setWaOptin] = useState(false);
    const currentUser = useSelector((state) => state.currentUser);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchCities = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/Cities/get`);
                setCities(response.data || []);
            } catch (error) {
                console.error('Error fetching cities:', error);
                setCities([]);
            } finally {
                setLoading(false);
            }
        };
        fetchCities();
    }, []);

    useEffect(() => {
        const fetchCountries = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/Countires/get`);
                setCountries(response.data || []);
            } catch (error) {
                console.error('Error fetching countries:', error);
                setCountries([]);
            } finally {
                setLoading(false);
            }
        };
        fetchCountries();
    }, []);

    const save = async () => {
        setErrorMsg("");

        if (!localStorageData || !localStorageData.length) {
            setErrorMsg("Your cart is empty.");
            return;
        }

        const required = {
            "First Name": formData.firstname,
            "Last Name": formData.lastname,
            "Title": formData.title,
            "Country": formData.country,
            "City": formData.city,
            "Address": formData.address1,
            "Mobile": formData.mobile,
        };

        const missing = Object.keys(required).filter((k) => !required[k] || String(required[k]).trim() === "");
        if (missing.length) {
            setErrorMsg("Please fill in: " + missing.join(", "));
            return;
        }

        if (!currentUser?.user?.id) {
            setErrorMsg("User not logged in");
            return;
        }

        setSaveIsLoading(true);

        // Map cart items to order format
        const orderItems = localStorageData.map((product) => ({
            item_id: product.id,
            quantity: product.quantity,
            price: product.price
        }));

        const orderData = {
            user_id: currentUser.user.id,
            items: orderItems,
            shipping_address: `${formData.address1}, ${formData.city}`,
            first_name: formData.firstname,
            last_name: formData.lastname,
            mobile: formData.mobile,
            wa_optin: waOptin
        };

        console.log("Submitting order to backend ->", orderData);

        try {
            // Submit to new Ootlob backend
            const response = await axios.post(
                `${process.env.REACT_APP_API_BASE_URL}/orders/create`,
                orderData
            );

            let data = response.data;
            if (typeof data === 'string') {
                const jsonStart = data.indexOf('{');
                if (jsonStart > 0) {
                    data = JSON.parse(data.substring(jsonStart));
                }
            }

            if (data.success) {
                console.log("Order created successfully", data);
                localStorage.removeItem("cart");
                setSaveIsLoading(false);
                setErrorMsg("");
                onClose();
                // Navigate to order confirmation
                navigate(`/OrderConfirmation/${data.order_id}`, {
                    state: { order: data }
                });
            } else {
                setErrorMsg(data.error || "Order creation failed");
                setSaveIsLoading(false);
            }
        } catch (error) {
            console.error("Error creating order:", error);
            setErrorMsg(error.response?.data?.error || error.message || "Failed to create order");
            setSaveIsLoading(false);
        }
    };

    if (!isOpen) return null;

    return (
        <div style={styles.modalOverlay} onClick={onClose}>
            <div style={styles.modalContent} onClick={(e) => e.stopPropagation()}>
                <h2>Shipping Information</h2>

                {errorMsg && <div style={styles.errorMsg}>{errorMsg}</div>}

                <CustomInput
                    placeholder="Title"
                    id="title"
                    value={formData.title}
                    onChange={handleInputChange}
                />
                <CustomInput
                    placeholder="First Name"
                    id="firstname"
                    value={formData.firstname}
                    onChange={handleInputChange}
                />
                <CustomInput
                    placeholder="Last Name"
                    id="lastname"
                    value={formData.lastname}
                    onChange={handleInputChange}
                />
                <CustomInput
                    placeholder="Mobile"
                    id="mobile"
                    value={formData.mobile}
                    onChange={handleInputChange}
                />
                <CustomInput
                    placeholder="Address"
                    id="address1"
                    value={formData.address1}
                    onChange={handleInputChange}
                />
                <CustomInput
                    placeholder="Zip Code"
                    id="zip"
                    value={formData.zip}
                    onChange={handleInputChange}
                />

                <select id="country" name="country" value={formData.country} onChange={customOnChange}
                    style={styles.select}
                >
                    <option value="">Select Country</option>
                    {countries.map((c) => (
                        <option key={c.id} value={c.id}>{c.name}</option>
                    ))}
                </select>

                <select id="city" name="city" value={formData.city} onChange={customOnChange}
                    style={styles.select}
                >
                    <option value="">Select City</option>
                    {cities.map((city) => (
                        <option key={city.id} value={city.id}>{city.name}</option>
                    ))}
                </select>

                <label style={{ display: 'flex', alignItems: 'center', gap: 8, margin: '10px 0', fontSize: 14, cursor: 'pointer' }}>
                    <input
                        type="checkbox"
                        checked={waOptin}
                        onChange={(e) => setWaOptin(e.target.checked)}
                    />
                    Send me offers and news on WhatsApp
                </label>

                <div style={styles.priceBreakdown}>
                    <p>Subtotal: ${(totalPrice - taxes - shipping).toFixed(2)}</p>
                    <p>Taxes: ${taxes.toFixed(2)}</p>
                    <p>Shipping: ${shipping.toFixed(2)}</p>
                    <h3>Total: ${totalPrice.toFixed(2)}</h3>
                </div>

                <div style={styles.buttonGroup}>
                    <button onClick={save} disabled={saveIsLoading} style={styles.submitBtn}>
                        {saveIsLoading ? "Processing..." : "Place Order"}
                    </button>
                    <button onClick={onClose} style={styles.cancelBtn}>Cancel</button>
                </div>
            </div>
        </div>
    );
};

const styles = {
    modalOverlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 1000
    },
    modalContent: {
        backgroundColor: 'white',
        padding: '40px',
        borderRadius: '10px',
        maxWidth: '500px',
        width: '90%',
        maxHeight: '90vh',
        overflowY: 'auto',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
    },
    errorMsg: {
        backgroundColor: '#fee',
        color: '#c33',
        padding: '10px',
        borderRadius: '5px',
        marginBottom: '15px',
        borderLeft: '4px solid #c33'
    },
    select: {
        width: '100%',
        padding: '10px',
        marginBottom: '15px',
        border: '1px solid #ddd',
        borderRadius: '5px'
    },
    priceBreakdown: {
        backgroundColor: '#f5f5f5',
        padding: '15px',
        borderRadius: '5px',
        marginTop: '20px',
        marginBottom: '20px'
    },
    buttonGroup: {
        display: 'flex',
        gap: '10px',
        marginTop: '20px'
    },
    submitBtn: {
        flex: 1,
        padding: '12px',
        backgroundColor: '#667eea',
        color: 'white',
        border: 'none',
        borderRadius: '5px',
        cursor: 'pointer',
        fontWeight: 'bold'
    },
    cancelBtn: {
        flex: 1,
        padding: '12px',
        backgroundColor: '#ddd',
        color: '#333',
        border: 'none',
        borderRadius: '5px',
        cursor: 'pointer'
    }
};

export default ShippingModal;